export default function printError (err) {
  if (Array.isArray(err)) {
    if (Array.isArray(err[0])) {
      return this.printError(err[0])
    } else if (typeof err[0] === 'object') {
      /* for(var key in err[0]){
        if (err.hasOwnProperty(key)){

        }
      } */
    }
    return err[0]
  }
  return err
}

export function systemError (response) {
  let err = response.data.errors || response.data.error || response.data
  if (Array.isArray(err)) {
    return err
  }
  return [err]
}



// WEBPACK FOOTER //
// ./src/utils/printError.js